import { setAuth, setProfile } from "../reducers/authReducer";
import { setConfig } from "../reducers/configReducer";
import axios from "axios";
import getError from "../utils/getError";
import setAuthToken from "../utils/setAuthToken";
import url from "../utils/url";
import { isPermitted } from "../utils/PermissionManager";

export const loginAdmin = (data, loginAfterFunction) => (dispatch) => {
  axios
    .post(url + "/auth", data)
    .then((res) => {
      if (res.data && res.data.success) {
        const { access_token } = res.data;
        setAuthToken(access_token);
        dispatch(
          saveConfig((res) => {
            if (res) {
              localStorage.setItem("skyadmin", access_token);
              dispatch(setAuth(true));
            }
            loginAfterFunction(res);
          })
        );
      } else {
        loginAfterFunction(false, "Result not successful no res.data.success");
      }
    })
    .catch((err) => {
      let dataString = JSON.stringify(data);
      let error = getError(err);

      if (typeof error !== "string") {
        error = JSON.stringify(err);
      }

      loginAfterFunction(false, error + " | " + dataString);
    });
};

export const saveConfig = (afterAsync) => (dispatch) => {
  axios
    .get(url + "/config")
    .then((res) => {
      if (res.data.result) {
        localStorage.setItem("config", JSON.stringify(res.data.result));
        let roles = res.data?.result?.profile?.roles;
        let notCrmDelivery = isPermitted(roles, [
          "admin",
          "accountant",
          "bd_purchase",
          "cn_purchase",
          "support",
          "marketing",
          "customer_care",
        ]);
        if (notCrmDelivery) {
          afterAsync(true);
          dispatch(setConfig(res.data.result));
          dispatch(setProfile(res.data.result?.profile));
        } else {
          localStorage.removeItem("skyadmin");
          localStorage.removeItem("config");
          setAuthToken(null);
          dispatch(setAuth(false));
          dispatch(setProfile(null));
          dispatch(setConfig(null));
          afterAsync(false);
          window.location.href = "/unauthorized";
        }
      }
    })
    .catch((err) => {});
};
export const saveProfile = () => (dispatch) => {
  axios
    .get(url + "/profile")
    .then((res) => {
      if (res.data?.result) {
        let role = res.data?.result?.role ? res.data?.result?.role : "";
        dispatch(setProfile(res.data?.result));
      }
    })
    .catch((err) => {});
};

export const logoutAdmin = (afterFunction) => (dispatch) => {
  localStorage.removeItem("skyadmin");
  localStorage.removeItem("config");
  setAuthToken(null);
  dispatch(setAuth(false));
  dispatch(setProfile(null));
  dispatch(setConfig(null));
  afterFunction(true);
};

export const setAdmin = (isAuthenticated) => (dispatch) => {
  dispatch(setAuth(isAuthenticated));
};
export const setAdminProfile = (data) => {
  return {
    type: "SET_ADMIN_PROFILE",
    payload: data,
  };
};

export const setAdminRole = (data) => {
  return {
    type: "SET_ADMIN_ROLES",
    payload: data,
  };
};
